import { Grid } from "@mui/material"
import { Id } from "../convex/_generated/dataModel"
import { DrawingCard } from "./DrawingCard"

type Drawing = {
  _id: Id<"drawings">
  _creationTime: number
  name: string
  previewUrl: string | null
}

type Props = {
  drawings: Drawing[]
  onDeleteDrawing: (drawingId: Id<"drawings">) => void
}

export function HomePageContent({ drawings, onDeleteDrawing }: Props) {
  return (
    <Grid container spacing={2} sx={{ padding: 3 }}>
      {drawings.map((drawing) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }} key={drawing._id}>
          <DrawingCard
            key={drawing._id}
            drawingId={drawing._id}
            name={drawing.name}
            previewUrl={drawing.previewUrl}
            onDelete={() => onDeleteDrawing(drawing._id)}
          />
        </Grid>
      ))}
    </Grid>
  )
}
